import { render, staticRenderFns } from "./quick-search.vue?vue&type=template&id=aa85f52c&"
import script from "./quick-search.vue?vue&type=script&lang=js&"
export * from "./quick-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports